<template>
  <div class="full container">
    <h1 class="title is-size-3-mobile is-size-2-tablet">Image Alpha</h1>
    <div class="content">
      <div class="control">
        <pull-down
          :items="image_sizes"
          :label="'image size:'"
          :default-value="0"
          @selectupdate="selectupdate"
        >
        </pull-down>
      </div>
      <div class="control">
        <input-field
          :label="'ask to generate something:'"
          :is-input="false"
          :maxlength="256"
          :default-value="'generate this:'"
          :placeholder="'say something'"
          :read-only="false"
          @inputupdate="onInputUpdate"
        ></input-field>
      </div>
      <div class="control">
        <button
          class="button"
          :class="isLoading ? 'is-loading' : ''"
          @click="generate"
        >
          <span>generate</span>
        </button>
      </div>
    </div>

    <div class="content image-wrapper" v-if="responseURL != ''">
      <figure>
        <img
          :src="`imagefolder/${responseURL}`"
          title="ai-generated from prompt"
          alt="An ai generated image"
        />
      </figure>
    </div>
    <image-prompts></image-prompts>
  </div>
</template>
<script>
import InputField from '@/components/InputField.vue';
import Pulldown from '@/components/Pulldown.vue';
import ImagePrompts from '@/components/ImagePrompts.vue';
import { ref } from 'vue';
import { useStore } from 'vuex';
export default {
  name: 'ImageAlpha',
  components: {
    'input-field': InputField,
    'pull-down': Pulldown,
    'image-prompts': ImagePrompts,
  },
  setup() {
    const store = useStore();
    let isLoading = ref(false);
    const input = ref('');
    const image_size = ref('1024x1024');
    const image_sizes = ['1024x1024', '1792x1024', '1024x1792'];
    const responseURL = ref('');
    const onInputUpdate = async (val) => {
      input.value = val;
    };

    const selectupdate = (index) => {
      image_size.value = image_sizes[index];
    };

    const generate = async () => {
      isLoading.value = true;
      responseURL.value = '';
      //     image_size is vooralsnog fixed op 1024x1024
      const body_vars = {
        prompt: input.value,
        image_size: image_size.value,
        style: 'vivid',
      };
      const response = await store.dispatch('post', {
        body_vars,
        end_point: 'getImage',
      });

      responseURL.value = response.data;
      console.log('response:', responseURL.value);
      isLoading.value = false;
    };

    return {
      isLoading,
      responseURL,
      generate,
      onInputUpdate,
      image_sizes,
      image_size,
      selectupdate,
    };
  },
};
</script>
<style lang="scss">
figure > img {
  width: 100%;
}

figure {
  max-width: 800px;
  &.mini {
    max-width: 100px;
  }
  &.extra {
    max-width: 800px;
  }
}
</style>
